import { createSelector } from "@ngrx/store";

import { IAppState } from "../states/app.state";
import { IProductState } from "../states/product.state";

const productState = (state: IAppState) => state.product;
const allProductState = (state: IAppState) => state.allProduct;

export const selectProductList = createSelector(
  productState,
  (state: IProductState) => state.Products?.data
);

export const selectAllProductList = createSelector(
  allProductState,
  (state: IProductState) => state.AllProducts?.data
);

export const selectProduct = createSelector(
  productState,
  (state: IProductState) => {
    state.Product?.data;
    if (state.Product) return state.Product.data;
  }
);
